let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("9dTI3")).then(() => parcelRequire('50j5y'));